import { Avatar, Button } from "flowbite-react";
import { useSelector } from "react-redux";
import { useState } from "react";
import { TbHandClick } from "react-icons/tb";

const RankProdutos = ({ acoes }) => {
  const { produtos } = useSelector((state) => state.produtos);
  const [limite, setLimite] = useState(10);

  if (!acoes || !produtos) return null;

  const visualizacoes = acoes
    .filter((a) => a.tipo_acao === "ver_produto" && a.produto_id)
    .reduce((acc, cur) => {
      acc[cur.produto_id] = (acc[cur.produto_id] || 0) + 1;
      return acc;
    }, {});

    const produtosOrdenados = Object.entries(visualizacoes)
    .sort((a, b) => b[1] - a[1])
    .map(([produto_id, total]) => {
      const produto = produtos.find((p) => p.id === produto_id);
      if (!produto) return null; // ignora produtos deletados
      return {
        id: produto_id,
        total,
        descricao: produto.descricao,
        fotoUrl: produto.fotos?.[0]?.url || null,
      };
    })
    .filter((p) => p !== null); // remove os nulos
  

  const total = produtosOrdenados.length;
  const opcoes = [10, 20, 50].filter((n) => total >= n);
  if (total > Math.max(...opcoes)) opcoes.push("Todos");

  return (
    <div className="bg-white rounded-2xl shadow p-4 mt-6">
      <div className="flex justify-between items-center mb-3">
        <p className="text-sm text-gray-500">Produtos Mais Clicados</p>
        <div className="flex gap-2">
          {opcoes.map((op, i) => (
            <Button
              key={i}
              size="xs"
              color="gray"
              onClick={() => setLimite(op === "Todos" ? total : op)}
              className={`text-xs px-2 py-0.5 rounded-full ${
                limite === (op === "Todos" ? total : op) ? "bg-gray-200" : ""
              }`}
            >
              Top {op}
            </Button>
          ))}
        </div>
      </div>

      <ul className="divide-y">
        {produtosOrdenados.slice(0, limite).map((item, index) => (
          <li key={item.id} className="flex items-center gap-3 py-2">
            <div className="flex items-center gap-2 w-12 justify-end">
              <span className="text-sm text-gray-600">{item.total}</span>
              <TbHandClick className="text-gray-400 text-lg" />
            </div>
            <Avatar
              img={`${process.env.REACT_APP_UPLOADS_URL}${item.fotoUrl}`}
              alt={item.descricao}
              size="md"
              rounded={false}
              className="w-10 h-10 object-cover aspect-square"
            />
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-800 break-words whitespace-pre-wrap leading-snug">
                {item.descricao}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RankProdutos;
